<template>
  <div>
    <div v-if="Array.isArray(notificaciones) && notificaciones.length">
      <div v-for="(n, i) in notificaciones" :key="i" :class="['alert', n.tipo]">
        {{ n.mensaje }}
      </div>
    </div>
    <div v-if="estado === 'bloqueada'">
      <div class="alert bloqueo">Acceso bloqueado. Contacte administración.</div>
    </div>
    <slot v-if="estado === 'activa' || estado === 'en_gracia'"></slot>
  </div>
</template>

<script>
export default {
  name: 'AdminEmpresaSuscripcionEstado',
  props: {
    ruc: { type: String, required: true }
  },
  data() {
    return {
      estado: '',
      notificaciones: [],
      lastAlertTime: null
    }
  },
  methods: {
    async fetchEstado() {
      const res = await fetch(`/api/empresa/${this.ruc}/suscripcion`)
      const data = await res.json()
      this.estado = data.estado
      this.notificaciones = Array.isArray(data.notificaciones) ? data.notificaciones : []
    }
  },
  mounted() {
    this.fetchEstado()
    // Si está en gracia, refrescar cada 12h
    setInterval(() => {
      if (this.estado === 'en_gracia') this.fetchEstado()
    }, 12 * 60 * 60 * 1000)
  }
}
</script>

<style scoped>
.alert { margin: 1rem 0; padding: 1rem; border-radius: 6px; }
.alert.alerta { background: #fffbe6; color: #b7791f; border: 1px solid #f6e05e; }
.alert.bloqueo { background: #ffe6e6; color: #c53030; border: 1px solid #feb2b2; }
</style>
